var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "15px",
    viewBox: "0 0 11 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "446D6A94-B505-4C69-A78F-82CDE3713B70") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Sub-Category--Approved/Flagged",
    transform: "translate(-1235.000000, -161.000000)",
    fill: "#A11515",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "red-flag-(1)",
    transform: "translate(1235.163002, 161.400000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2755215,0.871751953 C10.2221227,0.836018701 8.95298906,0 7.63989258,0 C6.57180879,0 5.78921572,0.434696484 5.03214258,0.85486377 C4.33396362,1.24243418 3.6742522,1.60839844 2.81469727,1.60839844 C1.99891758,1.60839844 1.16005737,1.18332554 0.804199219,0.979380615 L0.804199219,0 L0,0 L0,13.725 L0.804199219,13.725 L0.804199219,8.3197626 C1.30765474,8.56362261 2.04995742,8.84619141 2.81469727,8.84619141 C3.88278105,8.84619141 4.66537412,8.41149492 5.42244727,7.99132764 C6.12062622,7.60375723 6.78033765,7.23779297 7.63989258,7.23779297 C8.70601948,7.23779297 9.81884355,7.96738931 9.82983428,7.97484155 L10.4545898,8.38911138 L10.4545898,0.991121924 L10.2755215,0.871751953 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFlag);
export default __webpack_public_path__ + "static/media/red-flag.d022028945d1e034740efb5c83cee233.svg";
export { ForwardRef as ReactComponent };